export default {
  cotacao: {
    produtos: [],
  },
  cotacoes: [],
  filtros: {
    perPage: 20,
    page: 1,
  },
  campos: {
    id: 'ID',
    status: 'STATUS',
    classificacao: 'CLASSIFICACAO',
    filial: 'FILIAL',
    incoterm: 'INCOTERM',
    modal: 'MODAL',
    empresa: 'EMPRESA',
    portoOrigem: 'PORTO_ORIGEM',
    portoDestino: 'PORTO_DESTINO',
    solicitadoPor: 'SOLICITADO_POR',
    soliticadoEm: 'SOLICITADO_EM',
  },
  colDefault: 'SOLICITADO_EM',
  directionDefault: 'ASC',
  colunasItensSimulacao: [
    { text: 'NCM', value: 'ncm' },
    { text: 'Descrição', value: 'nomeProduto' },
    { text: 'Unidade de medida', value: 'unidadeMedida' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'valorUnitario', value: 'valorUnitario' },
    { text: 'Total', value: 'total' },
    { text: 'Moeda', value: 'moeda' },
    { text: 'Ações', value: 'actions' },
  ],
  colunasItensInvoice: [
    { text: 'NCM', value: 'ncm' },
    { text: 'Produto', value: 'nomeProduto' },
    { text: 'Quantidade', value: 'quantidade' },
  ],
  regimesApuracao: [
    {
      text: 'LUCRO REAL',
      value: 'LUCRO REAL',
    },
    {
      text: 'LUCRO PRESUMIDO',
      value: 'LUCRO PRESUMIDO',
    },
    {
      text: 'SIMPLES NACIONAL',
      value: 'SIMPLES NACIONAL',
    },
  ],
  portos: [
    {
      text: 'PORTONAVE - NAVEGANTES',
      value: 'Navegantes',
    },
    {
      text: 'PARANAGUA',
      value: 'Paranagua',
    },
    {
      text: "SANTOS 20'",
      value: 'Santos',
    },
    {
      text: "SANTOS 40'",
      value: 'Santos40',
    },
    {
      text: 'ITAPOÁ',
      value: 'Itapoa',
    },
    {
      text: 'AÉREO - NVT',
      value: 'AereoNVT',
    },
    {
      text: 'AÉREO - GRU',
      value: 'AereoGRU',
    },
    {
      text: "SUAPE 20'",
      value: 'Suape',
    },
    {
      text: "SUAPE 40'",
      value: 'Suape40',
    },
    {
      text: "ELO - PERNAMBUCO 20'",
      value: 'Pernambuco',
    },
    {
      text: "ELO - PERNAMBUCO 40'",
      value: 'Pernambuco40',
    },
    {
      text: 'PECEM - CEARÁ',
      value: 'Pecem',
    },
    {
      text: 'TECON - SALVADOR',
      value: 'TeconSalvador',
    },
    {
      text: 'BANDEIRANTE - SANTOS',
      value: 'BandeiranteSantos',
    },
    {
      text: 'BANDEIRANTE - GUARUJÁ',
      value: 'BandeiranteGuaruja',
    },
  ],
  filiaisBeneficios: [
    {
      text: 'SC (TTD 410)',
      value: 'SC (TTD 410)',
    },
    {
      text: 'RO (Benefício de Rondonia)',
      value: 'RO (Benefício de Rondonia)',
    },
    {
      text: 'PE (PRODEPE)',
      value: 'PE (PRODEPE)',
    },
    {
      text: 'PE (PEAP II)',
      value: 'PE (PEAP II)',
    },
  ],
  incoterms: [
    {
      text: 'EXW',
      value: 'EXW',
    },
    {
      text: 'FCA',
      value: 'FCA',
    },
    {
      text: 'CPT',
      value: 'CPT',
    },
    {
      text: 'CIP',
      value: 'CIP',
    },
    {
      text: 'FOB',
      value: 'FOB',
    },
    {
      text: 'CFR',
      value: 'CFR',
    },
    {
      text: 'CIF',
      value: 'CIF',
    },
  ],
  aplicacoesProdutos: [
    {
      text: 'Revenda',
      value: 'Revenda',
    },
    {
      text: 'Consumo',
      value: 'Consumo',
    },
    {
      text: 'Monofásico',
      value: 'Monofásico',
    },
    {
      text: 'Industrialização',
      value: 'Industrialização',
    },
  ],
  classificacoes: [
    {
      text: 'Conta e ordem',
      value: 'Conta e ordem',
    },
    {
      text: 'Encomenda',
      value: 'Encomenda',
    },
  ],
  categorias: [
    {
      text: 'Importação Cliente Ativo',
      value: 'ativo',
    },
    {
      text: 'Importação Cliente Prospect',
      value: 'prospect',
    },
  ],
  modalidades: [
    {
      text: 'Aéreo',
      value: 'Aéreo',
    },
    {
      text: 'Marítimo',
      value: 'Marítimo',
    },
    {
      text: 'Rodoviário',
      value: 'Rodoviário',
    },
  ],
  opcoesLogisticaNacional: [
    {
      text: 'SIM',
      value: true,
    },
    {
      text: 'NÃO',
      value: false,
    },
  ],
  opcoesAcondicionamentoCarga: [
    {
      text: 'Paletizada',
      value: 'Paletizada',
    },
    {
      text: 'Batida',
      value: 'Batida',
    },
  ],
  colunasItensRealizarSimulacao: [
    {
      text: 'NCM',
      value: 'ncm',
    },
    {
      text: 'Descrição',
      value: 'nomeProduto',
    },
    {
      text: 'Unidade de Medida',
      value: 'unidadeMedida',
    },
    {
      text: 'Quantidade',
      value: 'quantidade',
    },
    {
      text: 'Valor Unitário',
      value: 'valorUnitario',
    },
    {
      text: 'Total',
      value: 'total',
    },
    {
      text: 'Moeda',
      value: 'moeda',
    },
    {
      text: 'LI',
      value: 'li',
    },
    {
      text: 'II',
      value: 'ii',
    },
    {
      text: 'IPI',
      value: 'ipi',
    },
    {
      text: 'PIS',
      value: 'pis',
    },
    {
      text: 'COFINS',
      value: 'cofins',
    },
    {
      text: 'COFINS CUSTO',
      value: 'cofinsCusto',
    },
    {
      text: 'ICMS',
      value: 'icms',
    },
    {
      text: 'PIS SAIDA',
      value: 'pisSaida',
    },
    {
      text: 'COFINS SAIDA',
      value: 'cofinsSaida',
    },
    {
      text: 'MARKUP',
      value: 'markup',
    },
    {
      text: 'DESCONTO',
      value: 'desconto',
    },
  ],
  colunasItensRealizarSimulacaoContaOrdem: [
    {
      text: 'NCM',
      value: 'ncm',
    },
    {
      text: 'Descrição',
      value: 'nomeProduto',
    },
    {
      text: 'Unidade de Medida',
      value: 'unidadeMedida',
    },
    {
      text: 'Quantidade',
      value: 'quantidade',
    },
    {
      text: 'Valor Unitário',
      value: 'valorUnitario',
    },
    {
      text: 'Total',
      value: 'total',
    },
    {
      text: 'Moeda',
      value: 'moeda',
    },
    {
      text: 'LI',
      value: 'li',
    },
    {
      text: 'II',
      value: 'ii',
    },
    {
      text: 'IPI',
      value: 'ipi',
    },
    {
      text: 'PIS',
      value: 'pis',
    },
    {
      text: 'COFINS',
      value: 'cofins',
    },
    {
      text: 'COFINS CUSTO',
      value: 'cofinsCusto',
    },
    {
      text: 'ICMS',
      value: 'icms',
    },
    {
      text: 'TAXA TRUST',
      value: 'taxaTrust',
    },
  ],
  opcoesICMS: [
    {
      text: 'A (SC - NÃO CAMEX)',
      value: 'A',
    },
    {
      text: 'B (RO - NÃO CAMEX)',
      value: 'B',
    },
    {
      text: 'C (SC - CAMEX)',
      value: 'C',
    },
    {
      text: 'D (RO - NÃO CAMEX)',
      value: 'D',
    },
    {
      text: 'E (PEAP II - NÃO CAMEX)',
      value: 'E',
    },
    {
      text: 'F (PEAP II - CAMEX)',
      value: 'F',
    },
    {
      text: 'G (PRODEPE - NÃO CAMEX)',
      value: 'G',
    },
    {
      text: 'H (PRODEPE - CAMEX)',
      value: 'H',
    },
    {
      text: 'I (PRODEPE - NÃO CAMEX INTERESTADUAL)',
      value: 'I',
    },
    {
      text: 'J (PRODEPE - CAMEX INTERESTADUAL)',
      value: 'J',
    },
    {
      text: 'K (SC - INDUSTRIALIZAÇÃO)',
      value: 'K',
    },
    {
      text: 'L (SEM BENEFÍCIO - REVENDA P/ CONTRIBUINTE)',
      value: 'L',
    },
  ],
  opcoesIcmsContaOrdem: [
    {
      text: 'A (SC - NÃO CAMEX)',
      value: 'A',
    },
    {
      text: 'B (SC - CAMEX)',
      value: 'B',
    },
    {
      text: 'C (PEAP II - NÃO CAMEX)',
      value: 'C',
    },
    {
      text: 'D (PEAP II - CAMEX)',
      value: 'D',
    },
    {
      text: 'E (PRODEPE - NÃO CAMEX)',
      value: 'E',
    },
    {
      text: 'F (PRODEPE - CAMEX)',
      value: 'F',
    },
    {
      text: 'G (SC - INDUSTRIALIZAÇÃO NÃO CAMEX)',
      value: 'G',
    },
  ],
  opcoesFclLcl: [
    {
      text: 'FCL',
      value: 'FCL',
    },
    {
      text: 'LCL',
      value: 'LCL',
    },
  ],
  opcoesCargaPerigosa: [
    {
      text: 'SIM',
      value: true,
    },
    {
      text: 'NÃO',
      value: false,
    },
  ],
  opcoesMoeda: [
    {
      text: 'USD',
      value: 'USD',
    },
    {
      text: 'EUR',
      value: 'EUR',
    },
  ],
  colunasImpostos: [
    {
      text: '',
      value: 'descricao',
    },
    {
      text: 'Total em Dólar',
      value: 'valorTotalMoeda',
    },
    {
      text: 'Total em Reais',
      value: 'valorTotalReais',
    },
  ],
  opcoesAnuenciaLI: [
    {
      text: 'ANP',
      value: 'ANP',
    },
    {
      text: 'ANVISA',
      value: 'ANVISA',
    },
    {
      text: 'CIDASC',
      value: 'CIDASC',
    },
    {
      text: 'CNEN',
      value: 'CNEN',
    },
    {
      text: 'DECEX',
      value: 'DECEX',
    },
    {
      text: 'DFPC - BLUMENAU/FLORIPA',
      value: 'DFPC - BLUMENAU/FLORIPA',
    },
    {
      text: 'DFPC - BRASILIA',
      value: 'DFPC - BRASILIA',
    },
    {
      text: 'DPF',
      value: 'DPF',
    },
    {
      text: 'INMETRO',
      value: 'INMETRO',
    },
    {
      text: 'NÃO',
      value: 'NÃO',
    },
    {
      text: 'IBAMA',
      value: 'IBAMA',
    },
    {
      text: 'MAPA',
      value: 'MAPA',
    },
  ],
  opcoesTabelaColetaPorto: [
    {
      text: 'ITAJAÍ/NAVEGANTES: TAGLOG - ITAJAÍ',
      value: 'TAGLOG_ITAJAI',
    },
    {
      text: 'ITAJAÍ/NAVEGANTES - ITAJAÍ/NAVEGANTES',
      value: 'ITAJAI_NVT_ITAJAI_NVT',
    },
    {
      text: 'ITAPOÁ - ITAJAÍ/NAVEGANTES',
      value: 'ITAPOA_ITAJAI_NVT',
    },
    {
      text: 'OUTROS',
      value: 'OUTROS',
    },
  ],
  opcoesSeguroInternacional: [
    {
      text: '0,10%',
      value: 0.10,
    },
    {
      text: '0,125%',
      value: 0.125,
    },
    {
      text: '0,15%',
      value: 0.15,
    },
    {
      text: '0,20%',
      value: 0.20,
    },
    {
      text: '0,25%',
      value: 0.25,
    },
    {
      text: '0,30%',
      value: 0.30,
    },
  ],
  opcoesMajoracaoCofins: [
    {
      text: 'SIM',
      value: 'SIM',
    },
    {
      text: 'NÃO',
      value: 'NÃO',
    },
  ],
  salarioMinimo: 1412,
  valorBaseDespesasAdministrativas: 150,
  invoices: [],
  unidadesMedida: [
    {
      text: 'TONELADA METRICA LIQUIDA',
      value: 'TML',
    },
    {
      text: 'TONELADA METRICA',
      value: 'TM',
    },
    {
      text: 'BIG BAG',
      value: 'BG',
    },
    {
      text: 'MICROMETROS',
      value: 'MCT',
    },
    {
      text: 'PCT',
      value: 'PCT',
    },
    {
      text: 'CXS',
      value: 'CX',
    },
    {
      text: 'PAR',
      value: 'PAR',
    },
    {
      text: 'CJ',
      value: 'CJ',
    },
    {
      text: 'MILHEIRO',
      value: 'ML',
    },
    {
      text: 'MT',
      value: 'MT',
    },
    {
      text: 'POTE',
      value: 'POTE',
    },
    {
      text: 'FOLHAS',
      value: 'FL',
    },
    {
      text: 'FOLHA',
      value: 'FL',
    },
    {
      text: 'GARRAFA',
      value: 'GF',
    },
    {
      text: 'ROLO',
      value: 'RL',
    },
    {
      text: 'JOGO',
      value: 'JG',
    },
    {
      text: 'BOBINAS',
      value: 'BOB',
    },
    {
      text: 'BOBINA',
      value: 'BOB',
    },
    {
      text: 'DUZIAS',
      value: 'DZ',
    },
    {
      text: 'LIBRA',
      value: 'LIB',
    },
    {
      text: 'DISPLAY',
      value: 'DP',
    },
    {
      text: 'SACO',
      value: 'SC',
    },
    {
      text: 'DISPLAYS',
      value: 'DP',
    },
    {
      text: 'FARDOS',
      value: 'FDS',
    },
    {
      text: 'FARDO',
      value: 'FD',
    },
    {
      text: 'METROCUBICO',
      value: 'M3',
    },
    {
      text: 'METROQUADRADO',
      value: 'M2',
    },
    {
      text: 'PEÇA',
      value: 'PC',
    },
    {
      text: 'CAIXA DISPLAY',
      value: 'CDP',
    },
    {
      text: 'BARRIS',
      value: 'BAR',
    },
    {
      text: 'DUZIA',
      value: 'DZ',
    },
    {
      text: 'TONELADA MÉTRICA',
      value: 'TN',
    },
    {
      text: 'CAIXA DE PAPELÃO',
      value: 'CX',
    },
    {
      text: 'CAIXAS DE PAPELÃO',
      value: 'CX',
    },
    {
      text: 'METRO LINEAR',
      value: 'MTL',
    },
    {
      text: 'MILIGRAMAS',
      value: 'MG',
    },
    {
      text: 'MILILITROSS',
      value: 'MIL',
    },
    {
      text: 'TONELADAS',
      value: 'TO',
    },
    {
      text: 'MILIGRAMA',
      value: 'MG',
    },
    {
      text: 'BARRIL',
      value: 'BAR',
    },
    {
      text: 'AGULHAS',
      value: 'ZPK',
    },
    {
      text: 'PALLET',
      value: 'PLT',
    },
    {
      text: 'LITROS',
      value: 'LT',
    },
    {
      text: 'BALDE',
      value: 'BB',
    },
    {
      text: 'PACOTE',
      value: 'PT',
    },
    {
      text: 'GRAMAS',
      value: 'GR',
    },
    {
      text: 'UNIDADES',
      value: 'UND',
    },
    {
      text: 'COPOS',
      value: 'CP',
    },
    {
      text: 'QUILOGRAMAS',
      value: 'KG',
    },
    {
      text: 'JARDAS',
      value: 'YDS',
    },
    {
      text: 'CONJUNTOS',
      value: 'CJS',
    },
    {
      text: 'MILHEIROS',
      value: 'ML',
    },
    {
      text: 'METROS',
      value: 'MT',
    },
    {
      text: 'SACOS',
      value: 'SC',
    },
    {
      text: 'PACOTES',
      value: 'PC',
    },
    {
      text: 'ESTOJO PLASTICO',
      value: 'EP',
    },
    {
      text: 'CONES',
      value: 'CONE',
    },
    {
      text: 'CONE',
      value: 'CONE',
    },
    {
      text: 'BARRIL',
      value: 'BR',
    },
    {
      text: 'PECAS',
      value: 'PC',
    },
    {
      text: 'CONTAINER',
      value: 'CNTR',
    },
    {
      text: 'QUILOGRAMA LIQUIDO',
      value: 'KG',
    },
    {
      text: 'LIBRAS',
      value: 'LB',
    },
    {
      text: 'JOGOS',
      value: 'JG',
    },
    {
      text: 'GALAO',
      value: 'GL',
    },
    {
      text: 'BOLSAS',
      value: 'BL',
    },
    {
      text: 'ROLOS',
      value: 'RL',
    },
    {
      text: 'CENTIMETRO',
      value: 'CM',
    },
    {
      text: 'CAIXA',
      value: 'CX',
    },
    {
      text: 'QUILOGRAMA',
      value: 'KG',
    },
    {
      text: 'KIT',
      value: 'KT',
    },
    {
      text: 'TAMBORES',
      value: 'TB',
    },
    {
      text: 'TONELADA',
      value: 'TON',
    },
    {
      text: 'GARRAFAS',
      value: 'GF',
    },
    {
      text: 'CONJUNTO',
      value: 'CJ',
    },
    {
      text: 'DÚZIA',
      value: 'DZ',
    },
    {
      text: 'MEGAWATT HORA',
      value: 'MG',
    },
    {
      text: 'PARES',
      value: 'PAR',
    },
    {
      text: 'LITRO',
      value: 'LT',
    },
  ],
};
